export default __webpack_public_path__ + "static/media/model-1.29a526b8.png";